<!-- Template from page -->
<template>
  <section>
    <left-menu/>
    <modal-point-vaucher :data-modal="dataCodeVaucher"/>

    <div id="contentBack" class="content-back2">
      <a v-bind:href="'/'" class="nunito">
        <svg width="24" height="24" class="icon-color"><path d="M10,20V14h4v6h5V12h3L12,3,2,12H5v8Z"></path></svg>
        <span>Voltar ao início</span>
      </a>
    </div>

    <div id="mainContent" class="confirm-point">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">Ponto Registrado com Sucesso.</h1>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-4">
            <div class="col-xs-12 col-sm-12 col-md-12 default-box box-point-register">
              <div class="box-success">
                <div>
                  <img src="../../../../assets/img/icons/done.png" height="75" width="75" class="img-responsive" alt="done"/>
                </div>
              </div>

              <div class="info-text">
                <p class="certa">Registro confirmado em {{dataPointRegister.dataConfirm.date | formatDate}} às {{dataPointRegister.dataConfirm.date | formatHours}}</p>
                <small class="nunito">(horário oficial central)</small>
                <span class="nunito">Em instantes seu status será atualizado</span>
                <button @click="openModalVaucher()" class="btn-voucher" :disabled="loadingVaucher">
                  <div v-if="loadingVaucher" class="loading-btn">
                    <div class="spinner-btn">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5">
                      </div>
                    </div>
                  </div>
                  <div v-else class="group-btn">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2.5 18.3333L3.75 17.0833L5 18.3333L6.25 17.0833L7.5 18.3333L8.75 17.0833L10 18.3333L11.25 17.0833L12.5 18.3333L13.75 17.0833L15 18.3333L16.25 17.0833L17.5 18.3333V1.66663L16.25 2.91663L15 1.66663L13.75 2.91663L12.5 1.66663L11.25 2.91663L10 1.66663L8.75 2.91663L7.5 1.66663L6.25 2.91663L5 1.66663L3.75 2.91663L2.5 1.66663V18.3333ZM15 7.49996H5V5.83329H15V7.49996ZM15 10.8333H5V9.16662H15V10.8333ZM15 14.1666H5V12.5H15V14.1666Z" fill="#352DA5"/>
                    </svg>
                    Ver comprovante
                  </div>
                </button>
                <span class="vaucher nunito">Para ver o comprovante novamente, navegue até os detalhes deste dia.</span>
              </div>

              <router-link to="/" class="btn-back">
                <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.25 5.82578V0.875H13.125V3.1582L10 0.25L0 9.625H2.5V17.75H8.125V11.5H11.875V17.75H17.5V9.625H20L16.25 5.82578Z" fill="#352DA5"/>
                </svg>
                <span class="nunito">Voltar ao início</span>
              </router-link>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-8 box-img">
            <img v-if="isDark" src="../../../../assets/img/confirm-point/success-point-dark.png" class="img-responsive" alt="Confirmação de ponto"/>
            <img v-if="!isDark" src="../../../../assets/img/confirm-point/success-point.png" class="img-responsive" alt="Confirmação de ponto"/>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<!-- Script from page -->
<script>
  import leftMenu from '../../components/leftMenu.vue'
  import vueFooter from "../../components/footer";
  import ButtonBack from "../../components/buttonBack";
  import swal from "sweetalert";
  import {GET_POINT_VOUCHER, SHARE_INFO} from "../../../../urlConfig";
  import {UTIL_SERVICE} from "../../../../utils";
  import {REQUEST_SERVICE} from "../../../../requestConfig";
  import ModalPointVaucher from "../../modals/modalPointVaucher";

  export default {
    name: 'confirm-point',
    components: {
      ModalPointVaucher,
      ButtonBack,
      leftMenu,
      vueFooter
    },
    data() {
      return {
        pointDayIdLast: null,
        newPointRegister: 0,
        isDark: null,
        dataPointRegister: {
          dataConfirm: {
            id: null,
            date: null
          }
        },
        dataCodeVaucher: '',
        loadingVaucher: false,
        countModal: true,
      }
    },
    methods: {
      sendReceipt: function () {
        swal("Aviso", "Deseja enviar o comprovante por email?", {
          buttons: {
            cancel: "Cancelar",
            catch: {
              text: "Enviar",
              value: "send",
            }
          },
        })
          .then((value) => {
            if (value === "send") {
              let url = SHARE_INFO + this.dataPointRegister.dataConfirm.id;
              try {
                let browserInfo = UTIL_SERVICE.checkBrowser();
                url += "?deviceModel=" + browserInfo.name;
                url += "&deviceId=" + JSON.parse(window.localStorage.getItem('browserId'));
              } catch(err) { }

              UTIL_SERVICE.console("url send:", url);
              REQUEST_SERVICE.get(url).then((response) => {
                swal("Sucesso!", response.data, "success");
              }).catch(reason => {
                this.loadingRequest = false;
                // Show errors.
                reason.response.data.erros.map((value, index) => {
                  swal("Aviso", value.value, "error");
                });
              });
            }
          });
      },
      openModalVaucher() {
        this.loadingVaucher = true;
        if (this.countModal) {
          let url = GET_POINT_VOUCHER;
          if (this.newPointRegister) {
            url += `?totalPoints=${this.newPointRegister}`;

            if (this.pointDayIdLast) {
              url += `&lastPointId=${this.pointDayIdLast}`;
            }
          } else {
            if (this.pointDayIdLast) {
              url += `?lastPointId=${this.pointDayIdLast}`;
            }
          }

          REQUEST_SERVICE.get(url)
            .then((response) => {
              UTIL_SERVICE.console("RESULT GET_POINT_VOUCHER:", response.data);

              this.loadingVaucher = false;
              response.data.data.days.map((v) => {
                v.viewMore = false;
              });

              this.dataCodeVaucher = response.data
              $('#modalPointVaucher').modal();

              this.countModal = false
            }).catch(reason => {
            this.loadingVaucher = false;
            UTIL_SERVICE.console("RESULT ERROR:", reason.response.data);
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
        } else {
          $('#modalPointVaucher').modal();
          this.loadingVaucher = false;
        }
      },
    },
    beforeMount(){
      try {
        let chooseTheme = JSON.parse(window.localStorage.getItem('darkMode'));
        if (chooseTheme) {
          this.isDark = JSON.parse(window.localStorage.getItem('darkMode')).dark;
        }
      } catch (e) {}

      try {
        const dataConfigProgressPoint = UTIL_SERVICE.getStorage('configProgressPoint');
        if (dataConfigProgressPoint.newPointRegister) {
          this.newPointRegister = dataConfigProgressPoint.newPointRegister;
        }
      } catch (e) {}

      try {
        this.pointDayIdLast = UTIL_SERVICE.getStorage('pointDayIdLast');
      } catch (e) {}

      if (JSON.parse(window.localStorage.getItem('dataConfirmPoint')))
        this.dataPointRegister = JSON.parse(window.localStorage.getItem('dataConfirmPoint'));

      if (!this.dataPointRegister.dataConfirm.id || !this.dataPointRegister.dataConfirm.date) {
        this.$router.push({path: '/'});
      }
    }
  }
</script>
<style lang="scss" scoped>

.box-point-register {
  .info-text {
    .btn-voucher {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      border: 1px solid var(--linkColor);
      color: var(--linkColor);
      padding: 12px 0;
      border-radius: 4px;
      transition: .2s;
      background: var(--cardBackground);

      .group-btn {
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
          margin-right: 10px;
        }
      }

      &:hover {
        background: var(--linkColor);
        color: var(--cardBackground);

        svg {
          path {
            fill: var(--cardBackground);
          }
        }
      }

      .loading-btn {
        .rect1, .rect2, .rect3, .rect4, .rect5 {
          background: var(--linkColor);
        }
      }

      &:disabled {
        cursor: no-drop;
        filter: grayscale(1);

        &:hover {
          background: transparent;
          color: #191919;

          svg {
            path {
              fill: #191919;
            }
          }
        }
      }
    }

    .vaucher {
      margin-top: 10px;
      padding-bottom: 18px;
    }
  }

  .btn-back {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--linkColor);
    color: var(--linkColor);
    padding: 12px 0;
    border-radius: 4px;
    transition: .2s;
    background: var(--cardBackground);
    text-decoration: none;

    svg {
      margin-right: 10px;
    }

    &:hover {
      background: var(--linkColor);
      color: var(--cardBackground);

      svg {
        path {
          fill: var(--cardBackground);
        }
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/confirmPoint/confirmPoint.vue